export const getTodayStart = (): Date => {
  const d = new Date()
  d.setHours(0, 0, 0, 0)
  return d
}

export const getTomorrowStart = (): Date => {
  const t = getTodayStart()
  t.setDate(t.getDate() + 1)
  return t
}
